module.exports = __webpack_public_path__ + "media/images/athletes/2121-e45365274a04871b7598e4727425e80d.png";